import securityAnimation from 'assets/gifs/securityAnimation.gif';

import {
  LoaderContainer,
  LoaderGif,
  LoaderText,
  Wrapper,
} from 'components/Loaders/useAnimationLoader';

export const SecurityAnimationLoader = () => (
  <LoaderContainer data-testid="loader-container">
    <Wrapper>
      <LoaderGif src={securityAnimation} alt="loading..." />
      <LoaderText>
        Your account is being secured with strong encryption
      </LoaderText>
    </Wrapper>
  </LoaderContainer>
);
